import { createSelector } from 'reselect'

const getCardsById = state => {
  return state['view-board'].cards
}

const createSortedCardsInStatusSelector = (getStatusId) => createSelector(
  [getStatusId, getCardsById],
  (statusId, cardsById) =>
    Object.keys(cardsById)
      .filter(key =>
        !cardsById[key].isArchived &&
        !cardsById[key].isTemplate &&
        cardsById[key].statusId === statusId
      )
      .sort((a, b) => cardsById[a].statusPosition - cardsById[b].statusPosition)
      .map(key => cardsById[key])
)


export default createSortedCardsInStatusSelector
